import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons";
import { Register } from "../funtionsBD/Authservice";
import { Alert, Snackbar } from "@mui/material";
import { allclublist, allroles, usertype } from "../funtionsBD/Mainservice";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";

import "./AddGroup.css";
import { useNavigate } from "react-router-dom";

export const AddUser = () => {
  const [pictures, setPictures] = useState([]);
  const [imgvalue, setimgvalue] = useState();
  const [Type, setType] = useState([]);
  const [Role, setRole] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [club, setclub] = useState([]);
  const [success, setsuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [open2, setOpen2] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const info = JSON.parse(localStorage.getItem("user"));
  
  // Check if current user is Super Admin
  const isSuperAdmin = info?.type_user_id === 1 || info?.isSuperAdmin === true;

  const validate = (values) => {
    const errors = {};
    // Alias is optional now - removed requirement
    if (values.alias && values.alias.length > 100) {
      errors.alias = `${t("must")}`;
    }

    if (!values.fname) {
      errors.fname = `${t("require")}`;
    } else if (values.fname.length > 100) {
      errors.fname = `${t("must")}`;
    }
    if (!values.lname) {
      errors.lname = `${t("require")}`;
    } else if (values.lname.length > 100) {
      errors.lname = `${t("must")}`;
    }
    if (!values.email) {
      errors.email = `${t("require")}`;
    }
    if (!values.bday) {
      errors.bday = `${t("require")}`;
    }
    if (!values.password) {
      errors.password = `${t("require")}`;
    } else if (values.password.length < 6) {
      errors.password = `${t("must6")}`;
    } else if (values.password.length > 20) {
      errors.password = `${t("must20")}`;
    }

    return errors;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    gettyp();
    getclub();
    getrole();
  }, []);

  const gettyp = async () => {
    try {
      const response = await usertype();
      setType(response.data.data.typesUser);
    } catch (error) {
      console.log(error);
    }
  };
  const getrole = async () => {
    try {
      const response = await allroles();
      setRole(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getclub = async () => {
    try {
      const response = await allclublist();
      setclub(response.data.data);
      if (info.type_user_id === 1) {
        formik.setFieldValue("club_id", info.club_id);
      } else {
        const list = response.data.data || [];
        const own = list.find((c) => c.club_id === info.club_id) || list[0];
        formik.setFieldValue("club_id", info.club_id || own?.club_id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    setimgvalue(e.target.value);
    setPictures(file);
    formik.setFieldValue("img", URL.createObjectURL(file));
  };
  const handleadd = async (values, { resetForm }) => {
    try {
      console.log("🔄 Creating user with values:", values);
      console.log("🔄 Club ID:", values.club_id);
      console.log("🔄 User Type:", values.type);
      console.log("🔄 Pictures:", pictures);
      
      // Validate required fields
      if (!values.email) {
        throw new Error("Email is required");
      }
      if (!values.fname) {
        throw new Error("First name is required");
      }
      if (!values.lname) {
        throw new Error("Last name is required");
      }
      if (!values.password) {
        throw new Error("Password is required");
      }
      if (!values.bday) {
        throw new Error("Birth date is required");
      }
      if (!values.type) {
        throw new Error("User type is required");
      }
      if (!values.club_id) {
        throw new Error("Club is required");
      }
      
      const response = await Register(pictures, values);
      console.log("✅ User created successfully:", response.data);
      setsuccess(response.data.message || "User created successfully");
      setOpen(true);
      resetForm();
      setTimeout(() => {
        navigate("/UserManagement");
      }, 1000);
      setimgvalue("");
    } catch (error) {
      console.error("❌ Error creating user:", error);
      console.error("❌ Error response:", error.response);
      console.error("❌ Error data:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "Failed to create user";
      setError(errorMessage);
      setOpen2(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      alias: "",
      fname: "",
      lname: "",
      email: "",
      gender: "male",
      bday: "",
      // role: "",
      type: "",
      img: "",
      club_id: "",
      password: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      console.log("📝 Form submitted with values:", values);
      console.log("📝 Form errors:", formik.errors);
      handleadd(values, { resetForm });
    },
  });

  const agelimit = moment(new Date()).format("YYYY-MM-DD");
  const agerestrict = new Date().get;
  return (
    <form className="add-exercise" onSubmit={formik.handleSubmit}>
      <div className="edit-pic">
        {formik.values.img ? (
          <img src={formik.values.img} alt="" />
        ) : (
          <div className="profile_img_icon">
            {formik.values.fname ? formik.values.fname.slice(0, 1) : "+"}
          </div>
        )}
        <label htmlFor="img" className="edit-img-label">
          <FontAwesomeIcon icon={faCameraRetro} className="edit-camera" />
        </label>
      </div>
      <input
        className="input_addpicsvg"
        type="file"
        name="img"
        value={imgvalue}
        id="img"
        accept="image/*"
        onChange={handleFileInputChange}
      />
      <div className="input-details">
        {/* <div className="input-detail">
          <label htmlFor=""> {t("userrole")}</label>
          <select
            value={formik.values.role}
            onChange={formik.handleChange}
            name="role"
          >
            <option value="" disabled>
              Select Role
            </option>
            {Role.map((t, index) => (
              <option key={index} value={t.role_id}>
                {t.role_name}
              </option>
            ))}
          </select>
        </div> */}
        <div className="input-detail">
          <label htmlFor=""> {t("usertype")}</label>
          <select
            value={formik.values.type}
            onChange={formik.handleChange}
            name="type"
            style={{ padding: '0 10px' }} // Remove vertical padding, keep horizontal for text spacing
          >
            <option value="" disabled>
              Select Type
            </option>
            {Type.filter(t => {
              // Super Admin (type_user_id === 1) can only be added by Super Admins
              // Filter out Super Admin option for non-super admin users
              if (t.type_user_id === 1 && !isSuperAdmin) {
                return false;
              }
              return true;
            }).map((t, index) => (
              <option key={index} value={t.type_user_id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>
        {info.type_user_id !== 1 && (
          <div className="input-detail">
            <label htmlFor=""> {t("selectclub")}</label>
            <select
              value={formik.values.club_id}
              onChange={formik.handleChange}
              name="club_id"
              style={{ padding: '0' }} // Remove all padding to prevent club name cutoff
            >
              {club
                .filter((c) => !info.club_id || c.club_id === info.club_id)
                .map((t, index) => (
                <option key={index} value={t.club_id} style={{ padding: '8px' }}>
                  {t.club_name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="input-detail">
          <label htmlFor="">{t("alias")}</label>
          <input
            placeholder={t("writealias")}
            type="text"
            value={formik.values.alias}
            name="alias"
            onChange={formik.handleChange}
          />
        </div>

        <div className="input-detail">
          <label htmlFor=""> {t("firstname")}</label>
          <input
            placeholder={t("writename")}
            type="text"
            value={formik.values.fname}
            name="fname"
            onChange={formik.handleChange}
          />
        </div>
        {formik.errors.fname ? (
          <div className="validation_error">{formik.errors.fname}</div>
        ) : null}

        <div className="input-detail">
          <label htmlFor=""> {t("lastname")}</label>
          <input
            placeholder={t("writename")}
            type="text"
            value={formik.values.lname}
            name="lname"
            onChange={formik.handleChange}
          />
        </div>
        {formik.errors.lname ? (
          <div className="validation_error">{formik.errors.lname}</div>
        ) : null}

        <div className="input-detail">
          <label htmlFor=""> {t("birthdate")}</label>
          <input
            type="date"
            max={agelimit}
            value={formik.values.bday}
            name="bday"
            onChange={(e) => {
              formik.setFieldValue('bday', e.target.value);
            }}
            placeholder="dd/mm/yyyy"
          />{" "}
        </div>
        {formik.errors.bday ? (
          <div className="validation_error">{formik.errors.bday}</div>
        ) : null}

        <div className="input-detail">
          <label htmlFor=""> {t("gender")}</label>
          <div className="input-radio-btn">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formik.values.gender === "female"}
              onChange={formik.handleChange}
            />
            <label htmlFor="female"> {t("female")}</label>
          </div>
          <div className="input-radio-btn">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formik.values.gender === "male"}
              onChange={formik.handleChange}
            />
            <label htmlFor="male"> {t("male")}</label>
          </div>
        </div>

        <div className="input-detail">
          <label htmlFor=""> {t("mail")}</label>
          <input
            type="email"
            placeholder={t("enteremail")}
            value={formik.values.email}
            onChange={formik.handleChange}
            name="email"
          />
        </div>
        {formik.errors.email ? (
          <div className="validation_error">{formik.errors.email}</div>
        ) : null}

        <div className="input-detail">
          <label htmlFor=""> {t("password")}</label>
          <div className="input-passwordfield">
            <input
              type="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.password ? (
            <div className="validation_error">{formik.errors.password}</div>
          ) : null}
        </div>
      </div>

      <div className="input-detail">
        <button className="w-100" type="submit">
          {t("createuser")}
        </button>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={closealert}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={5000}
        onClose={() => setOpen2(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error" onClose={() => setOpen2(false)}>
          {error}
        </Alert>
      </Snackbar>
    </form>
  );
};
